import React from 'react'
import {yupParseErrors} from "@helpers/validate/validate";
import {ErrorMessage, typeValidationValueContext} from "@hooks/validate/types";
import {Schema} from 'yup';


interface IProps {
    value: any,
    validateSchema: Schema,
    realTime?: boolean,
    enabledValidation?: boolean,
    dependency?: unknown[],
    initialShowError?:boolean


}

export function useValidationValue({
                                       value,
                                       validateSchema,
                                       realTime = true,
                                       enabledValidation = true,
                                       dependency = [],
                                       initialShowError=false
                                   }: IProps): typeValidationValueContext {

    const [error, setError] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<ErrorMessage>();
    const [showError, setShowError] = React.useState<boolean>(initialShowError)

    const validateFn = () => {
        if (!enabledValidation) {
            setShowError(false)
            return true;
        }
        setShowError(true)

        try {
            const validate = validateSchema?.validateSync(value, {abortEarly: false});
            setError(false)
            setShowError(false)
            return true
        } catch (error) {
            if (error?.inner?.length && error.inner[0].path === '') {
                setErrorMessage(error.inner[0].message || error.inner[0].errors?.join(','))
                setError(true)
                return false
            }
            const errors = yupParseErrors(error);
            setErrorMessage(errors)
            setError(true)
            return false
        }
    }

    React.useEffect(() => {
        if (!realTime || !showError) {
            return
        }
        validateFn()
    }, dependency)


    return [validateFn, error, errorMessage]
}